import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import { BrowserRouter as Router } from "react-router-dom";
import reportWebVitals from './containers/reportWebVitals';
import './assets/styles/index.scss';
import 'bootstrap/dist/css/bootstrap.css';
import 'swiper/swiper-bundle.css';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
